'use strict';

var RefreshNotificationModalDirective = function RefreshNotificationModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/refresh-notification-modal.html'),
    controller: 'RefreshNotificationModalController',
    scope: {},
    link: function link($scope, $element) {
      $scope.hideModal = function () {
        $element.modal('hide');
      };
      $scope.$on('refresh-modal:openModal', function (events, gridId) {
        $scope.gridId = gridId;
        $element.modal('show');
      });
    }
  };
};
RefreshNotificationModalDirective.$inject = [];
module.exports = RefreshNotificationModalDirective;